import axios from 'axios';

const defaultState = {
    parameters: {},
    submitting: false,
    success: false,
    errors: {},
};

const mutations = {
    setParameter(state, {key, value}) {
        state.parameters[key] = value;
        if (state.errors[key]) {
            delete state.errors[key];
        }
    },
    setSubmitting(state, submitting = true) {
        state.submitting = submitting;
    },
    setErrors(state, errors) {
        state.errors = errors;
    },
    setSuccess(state, success = true) {
        state.success = success;
    },
    resetState(state) {
        state = {...defaultState};
    },
};

const actions = {
    submitContactUsForm({state, commit}) {
        if (state.submitting) {
            return;
        }
        commit('setSubmitting');

        axios.post('/api/contactUsSubmit', {
                ...state.parameters,
            })
            .then(function (response) {
                commit('setErrors', {}); // Clear any errors set in case an internal server error was set
                commit('setSuccess');
            })
            .catch(function (error) {
                if (!error.response || error.response.status !== 422) {
                    //  Handle non validation and general server errors with a generic error message
                    commit('setErrors', {'error': 'An error has occurred, please try again later.'});
                    return;
                }
                const responseErrors = error.response?.data?.errors ?? {};
                commit('setErrors', responseErrors);
                commit('setSubmitting', false);
            });
    },
};

export default {
    namespaced: true,
    actions,
    mutations,
    state: defaultState,
};
